document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".menu a");
  const path = window.location.pathname.replace(/\/+$/, "");

  links.forEach(link => {
    const href = link.getAttribute("href")?.replace(/\/+$/, "");
    if (href && href === path) {
      link.classList.add("is-active");
    }
  });
});